import { Route, Routes } from 'react-router';
import { combineLatest, map } from 'rxjs';
import { PlanData } from '../../models/PlanData';
import { TrustFamilyData } from '../../api/apis/TrustFamilyApi';
import { useAppStorage, useObservable } from '@aesop-fables/scrinium';
import { PlanCompartments, planStorageKey } from '../../data/plan';
import { TrustFamilyCompartments, trustFamilyStorageKey } from '../../data/trustFamily';
import { Loading } from '../../hooks/useLoading';
import UnfinishedPlan from './UnfinishedPlan';
import FinishedPlan from './FinishedPlan';

const PlanInfoDashboard = () => {
  const appStorage = useAppStorage();
  const trustFamilyDataCache = appStorage.retrieve<TrustFamilyCompartments>(trustFamilyStorageKey);
  const trustFamilyData = useObservable(
    trustFamilyDataCache.observe$<TrustFamilyData[]>('trustFamilyData'),
  );
  const trustFamily = trustFamilyData?.at(0);
  const planDataCache = appStorage.retrieve<PlanCompartments>(planStorageKey);
  const plan = useObservable(planDataCache.observe$<PlanData>('plan'));
  const initialized = useObservable(
    combineLatest([
      trustFamilyDataCache.findCompartment('trustFamilyData').initialized$,
      planDataCache.findCompartment('plan').initialized$,
    ]).pipe(
      map(([trustFamilyInitialized, planInitialized]) => trustFamilyInitialized && planInitialized),
    ),
  );

  return (
    <Routes>
      <Route
        path='/'
        element={
          initialized ? (
            trustFamily && plan ? (
              <FinishedPlan />
            ) : (
              <UnfinishedPlan trustFamily={trustFamily} plan={plan} />
            )
          ) : (
            <Loading />
          )
        }
      />
    </Routes>
  );
};

export default PlanInfoDashboard;
